import { render, staticRenderFns } from "./GasbotHeader.vue?vue&type=template&id=c9d5b0fa&scoped=true"
import script from "./GasbotHeader.vue?vue&type=script&lang=ts"
export * from "./GasbotHeader.vue?vue&type=script&lang=ts"
import style0 from "./GasbotHeader.vue?vue&type=style&index=0&id=c9d5b0fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9d5b0fa",
  null
  
)

export default component.exports